import { DayOfWeek } from '../enums';

const formatTwoDigits = (num: number): string => {
  return num.toString().padStart(2, '0');
};

export const generateTimeOptions = () => {
  const options = [];
  for (let i = 0; i < 24; i++) {
    // Format the time (24-hour format with leading zeros)
    const formattedTime = `${formatTwoDigits(i)}:00`;

    options.push({
      label: formattedTime,
      value: formatTwoDigits(i),
    });
  }
  return options;
};

export const DaysOfWeekInOrder = [
  DayOfWeek.MONDAY,
  DayOfWeek.TUESDAY,
  DayOfWeek.WEDNESDAY,
  DayOfWeek.THURSDAY,
  DayOfWeek.FRIDAY,
  DayOfWeek.SATURDAY,
  DayOfWeek.SUNDAY,
];
